/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IFabricantes from 'Infotrack@Modelos/smartStock/fabricantes/entidades/fabricantes';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import FabricantesCM from '../controladorModelo/fabricantesCM';
import { IFormularioFabricantesCVProps } from '../interfaces';
import { acciones, IEstadoFabricantes } from '../reductorFabricantes';
import FormularioFabricantesVista from '../vista/formularioFabricantesVista';
import { useSelector } from 'react-redux';

const estadoInicial: IFabricantes = {
    EmpresaId: '',
    FabricanteDescripcion: '',
    Estado: 1,
    AgenciaId: '',
};
const fabricantesCM = new FabricantesCM();

const FormularioFabricantesCV: React.FunctionComponent<IFormularioFabricantesCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadFabricantes }, dispatch] = useProveedor<IEstadoFabricantes>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IFabricantes>(estadoInicial);

    React.useEffect(() => {
        if (entidadFabricantes && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadFabricantes);
        } else {
            reiniciar();
        }
    }, [entidadFabricantes]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionFabricantes = () => {
        if (fabricantesCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarFabricantes,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarFabricantes = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            fabricantesCM
                .crearFabricantes({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            fabricantesCM
                .editarFabricantes({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioFabricantesVista
            accionCrearEditar={confirmarCreacionEdicionFabricantes}
            cambiarInfoFomulario={alCambiarValor}
            fabricantes={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioFabricantesCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioFabricantesCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioFabricantesCV);
